import ModalViewAll from './ModalViewAll'

export default ModalViewAll
// eslint-disable-next-line import/export
export * from './ModalViewAll'
